function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isTouchDevice = ('ontouchstart' in document.documentElement);

var RootMenuCtrl = /*#__PURE__*/function () {
  RootMenuCtrl.$inject = ["$element", "submenuService"];

  /* @ngInject */
  function RootMenuCtrl($element, submenuService) {
    _classCallCheck(this, RootMenuCtrl);

    this.$element = $element;
    this.submenuService = submenuService;
  }

  _createClass(RootMenuCtrl, [{
    key: "$postLink",
    value: function $postLink() {
      var _this = this;

      if (isTouchDevice === true) {
        this.$element[0].addEventListener("click", function (event) {
          if (_this.$element.classList.contains("active") === false) {
            event.preventDefault();
          }

          _this.$element[0].classList.add("active");
        });
        this.$element[0].addEventListener("mouseleave", function () {
          _this.$element[0].classList.remove("active");
        });
      }

      this.$element[0].addEventListener("mouseenter", function () {
        var otherActive = _this.submenuService.closeAnotherMenu();

        if (otherActive != null) {
          otherActive.getBlockOrientation().style.zIndex = 0;
        }
      });
    }
  }]);

  return RootMenuCtrl;
}();

export default RootMenuCtrl;